export enum IdentifierTypes {
  cif = 'cif',
  nie = 'nie',
  nif = 'identifier',
  passport = 'passport'
}
